export default __webpack_public_path__ + "static/media/polk_inventory_srank.ca0a40a2.png";